// eslint-disable-next-line no-restricted-imports
import I18n from 'I18n';
import createSingleI18nProvider from 'I18n/init/providers/createSingleI18nProvider';
import registerAllData from 'I18n/init/register/sync/registerAllData';
import getLang from 'I18n/utils/getLang';
import lang from 'i2l?query=sporks!../../lang/en.lyaml';
import { LOCALES } from '../constants/Locales';
export const DEFAULT_LOCALE = 'en';
export const toSupportedLocale = possibleLocale => LOCALES.includes(possibleLocale || '') ? possibleLocale : DEFAULT_LOCALE;
const loadedLocales = new Map();

/*
 * Every locale needs its own provider instance: `register` is deduped per
 * provider by `lang.source` and the locales to load are fixed when the
 * provider is created, so re-using one would never fetch a second locale's
 * chunk. The single provider deliberately leaves the page-level locale alone —
 * Quartz owns that — and only pulls the locale (plus the english fallback)
 * into the shared `I18n.translations` store, which is what
 * `I18n.text(key, { locale })` reads.
 */
const registerLocale = locale => {
  const I18nProvider = createSingleI18nProvider({
    language: locale
  });
  return Promise.all([I18nProvider.register(lang), registerAllData(I18nProvider)]);
};
export const loadLocale = locale => {
  const inFlight = loadedLocales.get(locale);
  if (inFlight) {
    return inFlight;
  }
  const pending = registerLocale(locale).catch(error => {
    loadedLocales.delete(locale);
    throw error;
  });
  loadedLocales.set(locale, pending);
  return pending;
};

/*
 * Mirrors `LocaleProvider`'s resolution so the locale blocked on during
 * `prepareApp` is the one the app renders with. `getLang()` reads the locale
 * Quartz derives from the browser, which it resolves in parallel with
 * `prepareApp`, so wait on `I18n.Info` before reading it.
 */
export const resolveInitialLocale = async search => {
  const localeQueryParam = new URLSearchParams(search).get('locale');
  if (localeQueryParam) {
    return toSupportedLocale(localeQueryParam);
  }
  await I18n.Info;
  return toSupportedLocale(getLang());
};